import "regenerator-runtime/runtime";
import { StoreWrapper } from "@core";

export class MonoprixStoreWrappper extends StoreWrapper {
  _config;

  constructor(config) {
    super();
    this._config = config;
  }

  /**
   * Force PoS with an extId
   * for instance, this is used after url parsing in cora by setting a cookie
   *  @param {string} posExtId
   */
  // eslint-disable-next-line no-unused-vars
  setPos(posExtId) {
    throw new Error("You must implement 'setPos' for this retailer");
  }

  /**
   * @returns host POS ext_id
   */
  getPosExtId() {
    return 'monoprix-plus';
  }

  /**
   * action on invalid host POS (open store selector)
   */
  hookCallback(isLogged, _isPosValid) {
    if (!isLogged) {
      window.location.assign('/login?destination=%2F');
    }
    return isLogged;
  }

  /**
   * @returns return true if shelf corresponds to a line of AVAILABLE_SHELVES
   */
   _searchIsAvailable(key) {
    return key.normalize("NFD").toLowerCase() === new URLSearchParams(window.location.search).get('q').normalize("NFD").toLowerCase();
  }

  /**
   * @returns return true if shelf corresponds to a line of AVAILABLE_SHELVES
   */
  _shelfIsAvailable(shelf) {
    return window.location.href.includes(shelf.id);
  }

  /**
   * @returns true if host store add is part of  AVAILABLE_SHELF
   */
  
  isAvailable() {
    const availableShelves = this._config.getAvailableShelves();
    const availableSearches = this._config.getAvailableSearches();
    const availableOnShelf = !!availableShelves.find(this._shelfIsAvailable)
    const availableOnSearch = window.location.href.includes('search') && !!availableSearches.find(this._searchIsAvailable.bind(this));
    return (
      (
        window.location.href.includes('https://courses.monoprix.fr') ||
        window.location.href.includes('https://www.rte.casino.osp.world')
      ) && (availableOnShelf || availableOnSearch)
    );
  }

  /**
   * to override if retailer do not use placeholder injection
   * @returns true if recipes should be injected on the page
   */
  availableOnPage() {
    // NEW : available if store not defined or is Paris ("france")
    const lastEvent = window.dataLayer.reverse().find(e => e.retailerRegionId)
    return (!lastEvent || lastEvent.retailerRegionId === 'france');
    
    // DEPRECATED : available if store is Paris ("france")
    // findLastIndex is not supported by firefox and chrome below 96
    // const lastEventIndex = window.dataLayer.reverse().findIndex(e => e.retailerRegionId === "france")
    // if (lastEventIndex === -1) { return false }

    // DEPRECATED: Recipes can be displayed if the region is France and if the slot for delivery has been chosen
    // return window.__INITIAL_STATE__.data.basket.slot && lastEventIndex > 1;
  }
}
